import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';

Snappy.Component.Poll = class Poll extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-poll';
	}

	constructor(element) {
		super(element);
        this.submitPoll = this.submitPoll.bind(this);
	}

	setVars() {
        this.$answers = this.$element.find('.fa-poll__answers');
        if (this.$answers.hasClass('results')) {
            //this.displayPollResults();
            this.disablePollSubmission();
        }
	}

	addEventListeners() {
        if (!this.$element[0].classList.contains('results')) {
            this.$element.find(':radio').on('keypress', this.submitPoll);
            this.$element.find('label').on('click', this.submitPoll);
        }
	}

	submitPoll(event) {
        let $parent = $(event.currentTarget).parent('li');
        $parent.find(':radio').prop('checked', true);

        const $form = $(event.currentTarget).parents('form');
        $.ajax({
            "url": $form.attr('action'),
            "method": $form.attr('method'),
            "data": $form.serialize()
        }).done(this.displayPollResults.bind(this));

	}

	displayPollResults(response) {
		//If you are finding errors in this section, it's most likely the answer value

        if (!this.$answers.hasClass('private')) {
            $.each(response.answers,
                (i, answer) => {
			        this.$answers
				        .addClass('results')
				        .find(`input[value=${answer.value}]`)
				        .siblings('.fa-poll__result-bar')
				        .css('width', `${answer.total}%`)
				        .next('.fa-poll__result-text')
				        .text(`${answer.total}%`);
			        $(answer).attr('disabled', 'disabled');
                });
        }
        else {
            this.$answers.hide();
            this.$element.find('.thankyou-box').removeClass('thankyou-box--hidden');
        }
		this.disablePollSubmission();

	}

	disablePollSubmission() {
		this.$element.find('label').off('click', this.submitPoll);
		this.$element.find(':radio').off('keypress', this.submitPoll);
	}

	render() {
		this.setVars();
		this.addEventListeners();
	}
};



// WEBPACK FOOTER //
// ./components/poll/scripts/poll.js